import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { RootState } from "@store";
import { ExportPowerBIProjectCommand, IPowerBIProjectsClient, PowerBIProjectsClient } from "app/ApiClient";
import { PowerBIProjectStatuses, initialPowerBIProjectState } from "./powerBIProjectState";
import { downloadFile } from "utils";

const powerBIProjectClient: IPowerBIProjectsClient = new PowerBIProjectsClient(process.env.REACT_APP_API_URL);

export const exportPowerBIProject = createAsyncThunk(
  "powerBIProject/export",
  async (command: Omit<ExportPowerBIProjectCommand, "batteries">, { rejectWithValue, getState }) => {
    try {
      const {
        projectsData: { pageContext },
      } = getState() as RootState;
      const batteries = pageContext.filter?.batteries ?? [];

      const result = await powerBIProjectClient.export({ ...command, batteries });
      downloadFile(result.questionsUrl);
      downloadFile(result.answersUrl);
      downloadFile(result.demographicsUrl);
      downloadFile(result.openEndsUrl);
      return result;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

const powerBIProjectSlice = createSlice({
  name: "powerBIProject",
  initialState: initialPowerBIProjectState,
  reducers: {
    resetPowerBIProject: () => initialPowerBIProjectState,
    setPowerBIProjectDialogOpen: (state, { payload }: PayloadAction<boolean>) => {
      state.isExportPowerBIProjectDialogOpen = payload;
      state.loading = LoadingState.idle;
    },
  },
  extraReducers: (builder) => {
    // createPowerBIProject
    builder.addCase(exportPowerBIProject.pending, (state) => {
      state.result = null;
      state.loading = LoadingState.pending;
      state.PowerBIProjectStatus = PowerBIProjectStatuses.InProgress;
    });

    builder.addCase(exportPowerBIProject.fulfilled, (state, { payload }) => {
      state.result = payload;
      state.loading = LoadingState.succeed;
      state.PowerBIProjectStatus = PowerBIProjectStatuses.Completed;
    });

    builder.addCase(exportPowerBIProject.rejected, (state, { error }) => {
      state.loading = LoadingState.failed;
      state.exportProjectErrorMessage = error.message;
      state.PowerBIProjectStatus = PowerBIProjectStatuses.Failed;
    });
  },
});

export const { resetPowerBIProject, setPowerBIProjectDialogOpen } = powerBIProjectSlice.actions;
export default powerBIProjectSlice.reducer;
